export const css = {
    root: '_3ttpnUYc _32FMVlPh',
    toggleButton: '_3ZU14Zre',
    ' _key': 'afcpe-theme/dojo/password-input'
};
export default css;
